export const getLabelValueObjectHelper = (value: any, options: any[]): { label: any; value: any } =>
  options.find(option => option.value === value);
